var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var pull = require('pull-stream/pull');

module.exports = function (source) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _read, sink, _yield$_awaitAsyncGen, end, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sink = function sink(read) {
              _read = function _read() {
                return new Promise(function (resolve, reject) {
                  read(null, function (end, data) {
                    if (end === true) return resolve({
                      end: end
                    });
                    if (end) return reject(end);
                    resolve({
                      data: data
                    });
                  });
                });
              };
            };

            pull(source, sink);

          case 2:
            if (!true) {
              _context.next = 14;
              break;
            }

            _context.next = 5;
            return _awaitAsyncGenerator(_read());

          case 5:
            _yield$_awaitAsyncGen = _context.sent;
            end = _yield$_awaitAsyncGen.end;
            data = _yield$_awaitAsyncGen.data;

            if (!end) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("break", 14);

          case 10:
            _context.next = 12;
            return data;

          case 12:
            _context.next = 2;
            break;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();
};